import ApiClient from './ApiClient';

class MultiChannelCampaignsAPI extends ApiClient {
  constructor() {
    super('multi_channel_campaigns', { accountScoped: true });
  }

  // Start a new run (planning) for a campaign.
  createRun(campaignId) {
    return axios.post(`${this.url}/${campaignId}/runs`);
  }

  getRun(campaignId, runId) {
    return axios.get(`${this.url}/${campaignId}/runs/${runId}`);
  }

  getRecipients(campaignId, runId, params = {}) {
    return axios.get(`${this.url}/${campaignId}/runs/${runId}/recipients`, {
      params,
    });
  }
}

export default new MultiChannelCampaignsAPI();
